export const apiCreate = (): string => '/commercial/statusHirings/create'
export const apiList = (id?: string): string =>
  !id ? '/commercial/statusHirings/' : `/commercial/statusHirings/view/${id}`
export const apiUpdate = (id: string): string =>
  `/commercial/statusHirings/update/${id}`
export const apiDelete = (id: string): string =>
  `/commercial/statusHirings/delete/${id}`
